"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getNodes(state, path) {
  if (path.length === 0) {
    return state.blocks;
  }

  return path.reduce(function (acc, val) {
    return acc[val].blocks || acc;
  }, state.blocks);
}

exports.getNodes = getNodes;

function getNode(state, path) {
  return path.reduce(function (acc, val) {
    return acc.blocks[val];
  }, state);
}

exports.getNode = getNode;